module.exports = __webpack_public_path__ + "static/media/maos-insta.4026a2a8.PNG";